export enum TimeTrackingBillingFrequencyEnum {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  SIX_MONTH = 'SIX_MONTH',
  YEAR = 'YEAR',
}
